<template>
  <div>
    <AddOrUpdateICD10MedicalDiagnosisCodeModal
      :is-referenced="true"
      :is-add-active.sync="toggleModal"
      resource="icd_10_diagnosis_codes"
      @create="onCreate"
      @refetchData="() => records = []"
    />

    <div class="d-flex align-content-between align-items-start">
      <v-select 
        class="flex-grow-1"
        :value="value" 
        :loading="loading"
        :options="records" 
        :close-on-select="true"
        :reduce="val => val.id" 
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        label="disease" 
        clearable 
        @search="fetchRecords"
        @input="onOptionSelected"
      >
        <template #list-header>
          <li class="d-flex align-content-between align-items-center" style="opacity: 0.8; text-align: center; padding: 5px;">
            <div class="flex-grow-1">Start typing to fetch records</div>
          </li>
        </template>

        <template #no-options>
          No options available
        </template>
      </v-select>

      <div v-if="can('icd_10_diagnosis_codes:CanAddNew')">
        <b-button size="sm" variant="no-outline" @click="onAddNew">
          <feather-icon icon="PlusCircleIcon" size="25" color="dodgerblue"></feather-icon>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { BButton } from 'bootstrap-vue'

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import AddOrUpdateICD10MedicalDiagnosisCodeModal from '@/@core/components/shared/admin/modals/AddOrUpdateICD10MedicalDiagnosisCodeModal.vue';

export default {
  components: {
    vSelect,
    BButton,

    AddOrUpdateICD10MedicalDiagnosisCodeModal
  },
  props: {
    value: {
      default: "",
      type: String,
      required: false,
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,

      records: [],
      storeName: "medicalCodeFrequencyStore",
    }
  },
  created() {
    if (this.value){
      this.fetchRecords(this.value, () => {});
    } else {
      this.records = this.getFrequencyStore(this.storeName)
    }
  },
  methods: {
    async fetchRecords(text, loadingMutator) {
      try {
        this.loading = true; 
        loadingMutator(true);

        const query = {
          page: 1,
          limit: 50,
          search: text || this.value,
        }

        const request = await this.useJwt().mainService.medicalDiagnosisCodes.list(query);
        const { data } = request.data;
        this.records = data;
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            variant: 'danger',
            text: error_message,
            icon: 'AlertTriangleIcon',
          },
        });
      } finally {
        this.loading = false;
        loadingMutator(false);
      }
    },
    async onCreate(form_data){
      try {
        this.loading = true;

        const result = await this.$swal({
          title: "Caution!!!",
          text: `Proceed to add new record?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: 'Yes',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (!result.isConfirmed) {
          return;
        }

        const { payload, save_and_new } = form_data;
        await this.useJwt().mainService.medicalDiagnosisCodes.create(payload);

        if (save_and_new){
          this.toggleModal = false;
          setTimeout(() => {
            this.toggleModal = true;
          }, 100)
        } else {
          this.toggleModal = false;
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Record added successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    onOptionSelected(medical_code_id){
      this.$emit('change', medical_code_id)

      const selectedOption = this.records.find(record => record._id === medical_code_id);
      if (selectedOption) {
        this.updateFrequencyStore(this.storeName, selectedOption);
      }
    },
    onAddNew(){
      this.toggleModal = true;
    },
  },
}
</script>
